import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Form, FormRow, FormGroup } from '@/components/Form'
import { DateInput } from '@/components/inputs/DateInput'
import styles from './UpdateDeadlineDialog.module.css'
import { Button } from '@/components/Button'

export interface UpdateDeadlineDialogProps {
  showing: boolean
  deadline: Date
  onDeadlineChange: (deadline: Date) => unknown
  onClose: () => unknown
  onUpdate: () => unknown
  isUpdatePending: boolean
}

export function UpdateDeadlineDialog({
  showing,
  deadline,
  onDeadlineChange,
  onClose,
  onUpdate,
  isUpdatePending,
}: UpdateDeadlineDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isUpdatePending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />

      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>Update Deadline</ModalSheetContentTitle>

          <ModalSheetContentDescription>
            Set new date and time for job completion
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>

        <ModalSheetContentBlock>
          <Form>
            <FormRow>
              <div className={styles.deadlineContainer}>
                <FormGroup label="Deadline">
                  <DateInput
                    value={deadline}
                    onChange={onDeadlineChange}
                    status="default"
                    calendarClassName={styles.deadlineCalendar}
                    testId="deadline-calendar-field"
                    clearIcon={false}
                    format="MM/dd/yyyy h:mm a"
                    includeTime
                    icon="dropdown"
                    minDate={new Date()}
                  />
                </FormGroup>
              </div>
            </FormRow>
          </Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            onPress={onClose}
            isDisabled={isUpdatePending}
            testId="update-deadline-close-button"
          />
          <Button
            label="Update"
            variant="primary"
            testId="update-deadline-submit-button"
            isPending={isUpdatePending}
            onPress={onUpdate}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
